import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Grid,
  Card,
  CardContent,
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Divider,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  Chat as ChatIcon,
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  Home as HomeIcon,
} from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
const baseUrl = process.env.REACT_APP_APP_URL;

// Helper function
const getDayName = (date) => {
  const daysOfWeek = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
  const day = new Date(date).getDay();
  return daysOfWeek[day];
};

const App = () => {
  const navigate = useNavigate();
  const [lessons, setLessons] = useState([]);

  const token = localStorage.getItem("CC_Token");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user ? user.id : null;

  useEffect(() => {
    if (!token || !userId) {
      console.error("Token or User ID is missing.");
      return;
    }

    axios
      .get(`${baseUrl}/api/lessons`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setLessons(response.data))
      .catch((error) => console.error("Error fetching lessons:", error));
  }, [token, userId]);

  const groupedLessons = lessons.reduce((acc, lesson) => {
    const day = getDayName(lesson.date);
    if (!acc[day]) acc[day] = [];
    acc[day].push(lesson);
    return acc;
  }, {});
  const handleNavigateToNotifications = () => {
    navigate("/notifications"); // Redirige vers la page notifications
  };
  const handleLogout = () => {
      localStorage.removeItem("CC_Token");
      localStorage.removeItem("user");
      toast.success("Vous avez été déconnecté avec succès.", {
        position: "top-right",
        autoClose: 3000,
      });
      setTimeout(() => navigate("/login"), 4000); // Redirect after toast
    };
    const handleProfile = () => {
      navigate("/Profile");
    };

  return (
    <div>
      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src={"../assets/cej.png"}
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      {/* Main Content */}
      <Box
        sx={{
          padding: "2rem",
          paddingTop: "80px", // Ajustement pour éviter le chevauchement avec le header
          paddingBottom: "80px", // Ajustement pour éviter le chevauchement avec le footer
          backgroundColor: "#f9f9f9",
          height: "calc(100vh - 160px)", // Hauteur totale - header - footer
          overflow: "auto", // Activer le défilement uniquement sur le contenu
        }}
      >
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            marginBottom: "2rem",
            color: "#002244",
            fontWeight: 700,
          }}
        >
          Emploi du Temps
        </Typography>
        <Grid container spacing={3}>
          {["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"].map((day) => (
            <Grid item xs={12} sm={6} md={3} key={day}>
              <Box
                sx={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  overflow: "hidden",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    padding: "1rem",
                    backgroundColor: "#002244",
                    color: "#ffffff",
                    fontWeight: "bold",
                  }}
                >
                  {day}
                </Typography>
                <Divider />
                <Box sx={{ padding: "1rem" }}>
                  {groupedLessons[day] && groupedLessons[day].length > 0 ? (
                    groupedLessons[day].map((lesson) => (
                      <Card
                        key={lesson.id}
                        sx={{
                          marginBottom: "1rem",
                          padding: "1rem",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <CardContent>
                          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {lesson.title}
                          </Typography>
                          <Typography variant="body2" sx={{ color: "#555" }}>
                            {lesson.time}
                          </Typography>
                          <Typography variant="body2" sx={{ color: "#555" }}>
                            {lesson.description}
                          </Typography>
                          <Typography variant="body2" color="error">{lesson.duration}</Typography>
                          <Typography variant="body2" sx={{ color: "#777" }}>
                          Coach: {lesson.instructor.name}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))
                  ) : (
                    <Typography variant="body2" sx={{ color: "#999", textAlign: "center" }}>
                      Aucun cours
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/emploi")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/home")}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/payment")}
          />
        </BottomNavigation>
      </Box>
    </div>
  );
};

export default App;
